import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@sdbn/appclient';
import { SharedModule } from 'src/app/shared/shared.module';

import { ApplicationClientCommonModule } from '@sdbn/appclient';

import { RFIDCardProtocolComponent } from './component/rfid-card-protocol.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    SharedModule,

    ApplicationClientCommonModule
  ],
  declarations: [
    RFIDCardProtocolComponent
  ]
})
export class RFIDCardProtocolModule { }

